module.exports = __webpack_public_path__ + "static/img/3136_phase_function_Paper_Points.c8c7d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3136_phase_function_Paper_Points.png
// module id = NSHN
// module chunks = 0